import type { LatLngExpression } from 'leaflet';
import { Polyline } from 'react-leaflet';
import { LineHelper } from '../../../../../helpers/line.helper';
import type { ICoordinate } from '../../../../../models/coordinate.model';
import type { ILine } from '../../../../../models/line.model';

function VehicleRoutePolylines({ coordinates, line }: { coordinates: ICoordinate[]; line: ILine }) {
  if (!coordinates || coordinates.length === 0) return null;

  const latLngsOnJourney: LatLngExpression[] = [];
  const foregroundColor = LineHelper.getForegroundColor(line);
  const backgroundColor = LineHelper.getBackgroundColor(line);
  const onJourneyPathOptions1 = { weight: 14, color: foregroundColor, opacity: 1, interactive: false };
  const onJourneyPathOptions2 = { weight: 8, color: backgroundColor, opacity: 1, interactive: false };

  for (let i = 0; i < coordinates.length; i += 1) {
    const coordinate = coordinates[i];
    if (!Number.isFinite(coordinate.latitude) || !Number.isFinite(coordinate.longitude)) continue;

    latLngsOnJourney.push([coordinate.latitude, coordinate.longitude]);
  }

  if (latLngsOnJourney.length < 2) return null;

  return (
    <>
      <Polyline positions={latLngsOnJourney} pathOptions={onJourneyPathOptions1} />
      <Polyline positions={latLngsOnJourney} pathOptions={onJourneyPathOptions2} />
    </>
  );
}

export default VehicleRoutePolylines;
